import React from 'react'
import { Badge, Box, Typography } from '@material-ui/core'
import { Button } from 'reactstrap'
import DoneIcon from '@material-ui/icons/Done'
import useMediaQuery from '@material-ui/core/useMediaQuery'

export default function Statuses({ setQuery, statusEnumSQ, query, btn, len, currentStatistics = [] }) {
  const max600 = useMediaQuery('(max-width:600px)')
  const max900 = useMediaQuery('(max-width:900px)')
  return (
    <Box
      style={{
        width: max600 ? `calc((100% / ${len} * 3) - 15px)` : max900 ? `calc((100% / ${len} * 3) - 10px)` : `calc((100% / ${len}) - 10px)`,
        marginTop: max900 && '5px',
        ':hover': {
          backgroundColor: '#000'
        }
      }}
      className='shadow'
    >
      <Button
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          padding: '12px 8px',
          width: '100%',
          height: '120px',
          position: 'relative',
          whiteSpace: 'normal',
          color: query.status === btn._id ? '#fff' : 'initial',
          backgroundColor: query.status === btn._id && '#3a3f51',
          overflow: 'hidden'
        }}
        onClick={() => {
          setQuery((prev) => ({ ...prev, status: btn._id, sortByStatus: false, page: 0 }))
        }}
      >
        {query.status === btn._id ? (
          <Box
            style={{
              position: 'absolute',
              top: '-10px',
              right: '-10px',
              backgroundColor: '#3a3f51',
              borderRadius: '20px',
              border: '1px solid #fff',
              padding: '3px',
              color: '#fff'
            }}
          >
            <Badge color='primary'>
              <DoneIcon />
            </Badge>
          </Box>
        ) : (
          ''
        )}
        <Typography
          style={{
            fontSize: '12px',
            lineHeight: 1.2,
            textAlign: 'center',
            flexShrink: 0,
            maxWidth: '100%'
          }}
        >
          {statusEnumSQ[btn._id]}
        </Typography>
        <Typography
          style={{
            marginTop: '6px',
            fontSize: '36px',
            fontWeight: '600',
            letterSpacing: '.15rem',
            flexShrink: 0
          }}
        >
          {btn.total}
        </Typography>
        <Typography
          style={{
            marginTop: '2px',
            fontSize: '12px',
            opacity: 0.85,
            flexShrink: 0
          }}
        >
          {currentStatistics.find((s) => s._id === btn._id)?.total ?? 0} current
        </Typography>
      </Button>
    </Box>
  )
}
